$(document).ready(function() {
    $('a#thumb-left-arrow').click(function(event) {
        event.preventDefault();
        $('div#media-container').animate({
            scrollLeft: "-=190"
        }, "medium", checkArrows);
    });
    
    $('a#thumb-right-arrow').click(function(event) {
        event.preventDefault();
        $('div#media-container').animate({
            scrollLeft: "+=190"
        }, "medium", checkArrows);
    });

    function checkArrows() {
        var $container = $('div#media-container');
        var $width = $('div.product-gallery').outerWidth();
        var $scrollWidth = $container[0].scrollWidth;    
        var $scrollLeft = $container.scrollLeft();
        
        // Check if scrolled to the very right
        if ($scrollWidth - $width <= $scrollLeft + 1) {
            $('a#thumb-right-arrow').css('opacity', 0.4);
        } else {
            $('a#thumb-right-arrow').css('opacity', 1);
        }

        // Check if scrolled to the very left
        if ($scrollLeft <= 0) {
            $('a#thumb-left-arrow').css('opacity', 0.4);
        } else {
            $('a#thumb-left-arrow').css('opacity', 1);
        }
    }

    $('div#media-container').scroll(checkArrows);

    // Initial check on page load
    checkArrows();
});
